import React, { useEffect, useState } from 'react';
import { Menu, Phone, X } from 'lucide-react';
import { Button } from './ui/button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Service Area',
    href: '#service-area'
  }, {
    name: 'Reviews',
    href: '#reviews'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy/95 backdrop-blur-md border-b border-lime/20 py-2' : 'bg-transparent py-4'}`} data-id="element-129">
        <div className="container mx-auto px-4 flex items-center justify-between h-[60px] md:h-auto" data-id="element-130">
          {/* Logo Wordmark */}
          <a href="#" className="flex items-center gap-2 z-50" data-id="element-131">
            <span className="font-heading text-3xl md:text-4xl tracking-wider text-white italic" data-id="element-132">
              AZ <span className="text-lime" data-id="element-133">JUNK</span> NERDS
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-6" data-id="element-134">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-white/80 hover:text-lime transition-colors uppercase tracking-wider" data-id="element-135">
                {link.name}
              </a>)}
          </nav>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center gap-4" data-id="element-136">
            <a href="tel:4252697387" className="flex items-center gap-2 text-white hover:text-lime transition-colors font-medium" data-id="element-137">
              <Phone className="w-4 h-4 text-lime" data-id="element-138" />
              <span data-id="element-139">(425) 269-7387</span>
            </a>
            <Button className="bg-lime text-navy hover:bg-lime/90 rounded-full font-bold px-6 shadow-[0_0_15px_rgba(163,230,53,0.4)] hover:shadow-[0_0_25px_rgba(163,230,53,0.6)] transition-all" data-id="element-140">
              GET FREE QUOTE
            </Button>
          </div>

          {/* Mobile Nav Toggle */}
          <div className="lg:hidden flex items-center" data-id="element-141">
            <button onClick={() => setMobileMenuOpen(true)} className="text-white hover:text-lime p-2" aria-label="Open menu" data-id="element-142">
              <Menu className="w-7 h-7" data-id="element-143" />
            </button>
          </div>
        </div>
      </header>

      {/* Full-screen mobile menu overlay */}
      {mobileMenuOpen && <div className="fixed inset-0 z-[60] flex flex-col" style={{
      backgroundColor: '#0F172A'
    }} data-id="element-144">
          {/* Close button */}
          <div className="flex justify-end p-6" data-id="element-145">
            <button onClick={() => setMobileMenuOpen(false)} className="text-lime hover:text-lime/80 transition-colors" aria-label="Close menu" data-id="element-146">
              <X className="w-8 h-8" data-id="element-147" />
            </button>
          </div>

          {/* Menu items - centered */}
          <nav className="flex-1 flex flex-col items-center justify-center gap-5" data-id="element-148">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-2xl font-bold font-heading tracking-wider text-white uppercase hover:text-lime transition-colors border-l-4 border-transparent hover:border-lime pl-4 py-1" data-id="element-149">
                {link.name}
              </a>)}
          </nav>

          {/* Bottom actions */}
          <div className="flex flex-col items-center gap-4 px-8 pb-12" data-id="element-150">
            <a href="tel:4252697387" className="flex items-center gap-3 text-white text-lg font-medium" data-id="element-151">
              <Phone className="w-5 h-5 text-lime" data-id="element-152" />
              <span data-id="element-153">(425) 269-7387</span>
            </a>
            <Button onClick={() => setMobileMenuOpen(false)} className="bg-lime text-navy hover:bg-lime/90 rounded-full font-bold w-full h-14 text-lg shadow-[0_0_20px_rgba(163,230,53,0.5)]" data-id="element-154">
              GET FREE QUOTE
            </Button>
          </div>
        </div>}
    </>;
}